export default __webpack_public_path__ + "1af1cb77df1a232c1222afe56e03e18c.png";